/**
 * Pure helpers for StbMarkdown.
 *
 * Kept out of the component so they can be unit tested: StbMarkdown imports
 * react-markdown, which is ESM and is not transformed by the CRA jest setup.
 */

/**
 * GitHub-style heading anchor.
 *
 * Must stay in step with `anchor()` in the documentation publisher
 * (toolbox_docs/build/publish.py) — the manifest's heading anchors are matched against
 * the `data-anchor` attributes rendered here when the drawer scrolls to a section.
 */
export const toAnchor = (text: string): string | undefined => {
  const trimmed = (text || '').trim();
  if (!trimmed) return undefined;
  return trimmed
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

/** Resolve a markdown image path against a bundle base, leaving absolute URLs alone. */
export const resolveAssetSrc = (src?: string, assetBase?: string): string | undefined => {
  if (!src || !assetBase) return src;
  if (/^(https?:)?\/\//.test(src) || src.startsWith('/') || src.startsWith('data:')) {
    return src;
  }
  return `${assetBase}${src}`;
};
